module.exports = __webpack_public_path__ + "img/flag.21297fc7.png";